export default "__VITE_ASSET__DMxMKxEJ__"